import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import { employeeApi } from "./employeeAPI";
import { RootState } from "../../store";
import { fetchLeaveApplications } from "../leaveApplication/leaveApplicationAPI";
import { fetchMessages } from "../message/messageAPI";
import { overtimeApi } from "../overtime/overtimeAPI";
import { rosterApi } from "../rosteredShift/rosterApi";
import { shiftApi } from "../shift/shiftApi";
import { unavailableEventApi } from "../unavailableEvent/unavailableEventApi";

const employeeAdapter = createEntityAdapter<Employee>();

const initialState = employeeAdapter.getInitialState();

const employeeSlice = createSlice({
  name: "employees",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeaveApplications.fulfilled, (state, action) => {
        employeeAdapter.upsertMany(state, action.payload.employees);
      })
      .addCase(fetchMessages.fulfilled, (state, action) => {
        employeeAdapter.upsertMany(state, action.payload.employees);
      })
      .addMatcher(employeeApi.endpoints.fetchEmployees.matchFulfilled, (state, action) => {
        employeeAdapter.upsertMany(state, action.payload.employees);
      })
      .addMatcher(rosterApi.endpoints.fetchAll.matchFulfilled, (state, action) => {
        employeeAdapter.upsertMany(state, action.payload.employees);
      })
      .addMatcher(shiftApi.endpoints.fetchWorkedShift.matchFulfilled, (state, action) => {
        employeeAdapter.upsertMany(state, action.payload.employees);
      })
      .addMatcher(overtimeApi.endpoints.getOvertimes.matchFulfilled, (state, action) => {
        employeeAdapter.upsertMany(state, action.payload.employees);
      })
      .addMatcher(unavailableEventApi.endpoints.fetchEmployeeAvailability.matchFulfilled, (state, action) => {
        employeeAdapter.upsertMany(state, action.payload.employees);
      })
      .addMatcher(employeeApi.endpoints.xeroImport.matchFulfilled, employeeAdapter.upsertOne)
      .addMatcher(employeeApi.endpoints.updateEmployee.matchFulfilled, (state, action) => {
        employeeAdapter.upsertOne(state, action.payload);
      });
  },
});

export const { selectById: selectEmployeeById, selectAll: selectAllEmployees } =
  employeeAdapter.getSelectors<RootState>((state) => state.employee);

export { employeeAdapter, employeeSlice };
